<template>
    <ResourceInput
        v-if="options"
        label="Template"
        attribute="template"
        type="select"
        :options="options"
    />
</template>

<script>
import { inject } from "vue";
import Kernel from "@oilstone/kernel";

export default {
    setup() {
        const type = inject('type');
        const components = Kernel.resolve('resourceRegistry').find(type).config.components;
        const options = [
            {
                label: 'default',
                value: '',
            }
        ];

        if (components.webRecord && components.webRecord.templates) {
            components.webRecord.templates.forEach(template => {
                options.push({
                    label: template.label,
                    value: template.key,
                })
            });
        }

        return {
            options
        }
    }
}
</script>
